import { mutationTypes, actionTypes } from '../access-keys'
import defaultStates from './meter-reading/default-states'
import { map } from '../helpers/mapper'

export default {
  namespaced: true,
  state: defaultStates.forRoot(),
  getters: {},
  mutations: {
    [mutationTypes.meterReading.RESET_STATE](state) {
      map(defaultStates.forRoot(), state)
    },
    [mutationTypes.meterReading.ACTIVATE_STEP](state, step) {
      if (step > state.stepActiveTo) {
        state.stepActiveTo = step
      }
    },
    [mutationTypes.meterReading.UNACTIVATE_STEP](state, step) {
      if (step < state.stepActiveTo) {
        state.stepActiveTo = step
      }
    }
  },
  actions: {
    [actionTypes.meterReading.RESET_FORM]({ commit }) {
      commit(mutationTypes.meterReading.RESET_STATE)
      commit(mutationTypes.meterReading.step1.RESET_STATE_ROOT, null, {
        root: true
      })
      commit(mutationTypes.meterReading.step2.RESET_STATE_ROOT, null, {
        root: true
      })
      commit(mutationTypes.meterReading.step3.RESET_STATE_ROOT, null, {
        root: true
      })
      commit(mutationTypes.meterReading.step4.RESET_STATE_ROOT, null, {
        root: true
      })
    }
  },
  modules: {
    step1: {
      namespaced: true,
      state: defaultStates.forStep1(),
      getters: {},
      mutations: {
        [mutationTypes.meterReading.step1.RESET_STATE](state) {
          map(defaultStates.forStep1(), state)
        },
        [mutationTypes.meterReading.step1.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.meterReading.step1.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.meterReading.step1.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.meterReading.ACTIVATE_STEP_ROOT, 2, {
            root: true
          })
        }
      }
    },
    step2: {
      namespaced: true,
      state: defaultStates.forStep2(),
      getters: {},
      mutations: {
        [mutationTypes.meterReading.step2.RESET_STATE](state) {
          map(defaultStates.forStep2(), state)
        },
        [mutationTypes.meterReading.step2.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.meterReading.step2.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.meterReading.step2.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.meterReading.step3.MANAGE_USER_COORDINATES_CHANGES_ROOT, payload, { root: true })
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.meterReading.ACTIVATE_STEP_ROOT, 3, {
            root: true
          })
        }
      }
    },
    step3: {
      namespaced: true,
      state: defaultStates.forStep3(),
      getters: {},
      mutations: {
        [mutationTypes.meterReading.step3.RESET_STATE](state) {
          map(defaultStates.forStep3(), state)
        },
        [mutationTypes.meterReading.step3.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        },
        [mutationTypes.meterReading.step3.MANAGE_USER_COORDINATES_CHANGES](state, step2FormDatas) {
          if (state.formDatas === null) {
            return
          }
          let email = step2FormDatas.email
          let phone = step2FormDatas.phoneNumber
          if (email === null || email.length === 0) {
            state.formDatas.emailConfirmation = { checked: false, email: '' }
          }
          if (phone === null || phone.length === 0) {
            state.formDatas.smsConfirmation = { checked: false, phone: '' }
          }
        }
      },
      actions: {
        [actionTypes.meterReading.step3.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.meterReading.step3.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.meterReading.ACTIVATE_STEP_ROOT, 4, {
            root: true
          })
        },
        [actionTypes.meterReading.step3.RESET_STEP]({ commit, state }) {
          commit(mutationTypes.meterReading.step3.RESET_STATE)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.meterReading.UNACTIVATE_STEP_ROOT, 3, {
            root: true
          })
        }
      }
    },
    step4: {
      namespaced: true,
      state: defaultStates.forStep4(),
      getters: {},
      mutations: {
        [mutationTypes.meterReading.step2.RESET_STATE](state) {
          map(defaultStates.forStep4(), state)
        }
      },
      actions: {}
    }
  }
}
